import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { downloadPages } from '../constants'

class DownloadButton extends Component {
  static propTypes = {
    pageName: PropTypes.string.isRequired,
  }

  handleButtonClick = () => {
    const { pageName } = this.props
    window.location = downloadPages[pageName].redirectUrl
  }

  render() {
    const { pageName } = this.props
    const image = downloadPages[pageName].image
    return (
      <button className="w-100 flex-auto bn bg-transparent pointer" onClick={this.handleButtonClick}>
        <img src={`${image}`} alt={pageName} />
      </button>
    )
  }
}

export default DownloadButton



// WEBPACK FOOTER //
// ./src/components/DownloadButton.js